/** Typed DOM helpers are shared across games; see @jpj/game-shell. */
import { $ } from "@jpj/game-shell";
export { $ } from "@jpj/game-shell";

/* Frequently used elements, cached once (module scripts run after parse). */
export const gridEl = $("grid");
export const circlesEl = $("circles");
export const treesEl = $("trees");
export const noriasEl = $("norias");
export const previewEl = $("preview");
export const stageEl = $("stage");
